import { $createParagraphNode, ElementNode, type LexicalNode, type SerializedElementNode } from "lexical";

import type { RecommendationKind } from "~/shared/enums";

import { RECOMMENDATION_BOX_CLASSES } from "../const";
import { $isRecommendationButtonsNode } from "./RecommendationButtonsNode";

type SerializedRecommendationWrapperNode = SerializedElementNode & { kind: RecommendationKind };

export class RecommendationWrapperNode extends ElementNode {
  __kind: RecommendationKind;

  __markId: string | null = null;

  static getType(): string {
    return "recommendation-wrapper";
  }

  static clone(node: RecommendationWrapperNode): RecommendationWrapperNode {
    return new RecommendationWrapperNode(node.__kind, node.__key, node.__markId);
  }

  constructor(kind: RecommendationKind, key?: string, markId: string | null = null) {
    super(key);
    this.__kind = kind;
    this.__markId = markId;
  }

  getKind(): RecommendationKind {
    return this.__kind;
  }

  getMarkId(): string | null {
    return this.__markId;
  }

  setMarkId(markId: string | null): void {
    const writable = this.getWritable();
    writable.__markId = markId;
  }

  // eslint-disable-next-line class-methods-use-this
  createDOM(): HTMLElement {
    const div = document.createElement("div");
    div.classList.add(...RECOMMENDATION_BOX_CLASSES.split(" "), "ml-[-13px]", "px-3");
    div.style.width = "calc(100% + 26px)";
    return div;
  }

  // eslint-disable-next-line class-methods-use-this
  updateDOM(): false {
    return false;
  }

  static importJSON(serializedNode: SerializedRecommendationWrapperNode): LexicalNode {
    return new RecommendationWrapperNode(serializedNode.kind);
  }

  exportJSON(): SerializedRecommendationWrapperNode {
    return {
      type: RecommendationWrapperNode.getType(),
      kind: this.getKind(),
      version: 1,
      indent: 0,
      direction: "ltr",
      format: "",
      children: [],
    };
  }

  remove() {
    if (this.getPreviousSibling() === null && this.getNextSibling() === null) {
      this.insertBefore($createParagraphNode());
    }
    super.remove();
  }

  // eslint-disable-next-line class-methods-use-this
  isShadowRoot(): true {
    return true;
  }

  isEmpty(): boolean {
    return this.getChildren().filter((e) => !$isRecommendationButtonsNode(e)).length === 0;
  }

  // eslint-disable-next-line class-methods-use-this
  canBeEmpty(): false {
    return false;
  }
}

export function $createRecommendationWrapperNode(kind: RecommendationKind): RecommendationWrapperNode {
  return new RecommendationWrapperNode(kind);
}

export function $isRecommendationWrapperNode(node?: LexicalNode): node is RecommendationWrapperNode {
  return node instanceof RecommendationWrapperNode;
}
